import './PlatformSider.less';

import { Drawer, Input } from 'antd';
import { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { ReactComponent as MainLogo } from 'assets/img/main-logo.svg';
import classNames from 'classnames';
import RevxFlexLayout from 'components/RevxFlexLayout';

import OrgSwitch from './components/OrgSwitch';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { SideLeftIcon, SideRightIcon } from 'components/Icons';

interface TriggerProps {
  onClick?: React.MouseEventHandler;
  fixed: boolean;
  direction?: 'left' | 'right';
}

export const Trigger = ({
  onClick,
  fixed,
  direction = 'right',
}: TriggerProps) => {
  return (
    <div
      className={classNames('platform-sider-trigger', {
        fixed,
      })}
      onClick={onClick}
    >
      {direction === 'right' ? <SideRightIcon /> : <SideLeftIcon />}
    </div>
  );
};

const PlatformSider = () => {
  const expanded = useAppSelector((state) => state.org.siderExpanded);
  const dispatch = useAppDispatch();
  const [searchValue, setSearchValue] = useState<string>('');

  const { t } = useTranslation();
  return (
    <div className="platform-sider-con">
      <Trigger
        fixed
        onClick={() => {
          dispatch.org.toggleSider(true);
        }}
      />
      <Drawer
        title={
          <RevxFlexLayout justify="space-between">
            <MainLogo />
            <Trigger
              direction="left"
              fixed={false}
              onClick={() => dispatch.org.toggleSider(false)}
            />
          </RevxFlexLayout>
        }
        className="platform-sider"
        placement="left"
        width={344}
        closable={false}
        onClose={() => {
          dispatch.org.toggleSider(false);
        }}
        visible={expanded}
      >
        <Input
          className="search-box"
          placeholder={t('platform.sider.searchPlaceholder')}
          prefix={<SearchOutlined className="site-form-item-icon" />}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
        />
        <OrgSwitch searchValue={searchValue} />
      </Drawer>
    </div>
  );
};

export default PlatformSider;
